// src/pages/services/ManagementSystemConsulting.jsx
import React from 'react';
import ServiceTemplate from '../../components/services/ServiceTemplate';
import consultingImg from '../../assets/images/expertise.jpg';

const ManagementSystemConsulting = () => {
  const features = [
    {
      icon: '📋',
      title: 'Process Optimization',
      description: 'Streamline operations and eliminate inefficiencies in your workflows'
    },
    {
      icon: '🎯',
      title: 'Strategic Planning',
      description: 'Comprehensive roadmaps for sustainable business transformation'
    },
    {
      icon: '📊',
      title: 'Performance Metrics',
      description: 'KPI-driven approach to measure and improve outcomes'
    },
    {
      icon: '🔄',
      title: 'Change Management',
      description: 'Seamless transition strategies for organizational adoption'
    },
    {
      icon: '🏭',
      title: 'Industry Best Practices',
      description: 'Implementation of proven management methodologies'
    },
    {
      icon: '📈',
      title: 'Continuous Improvement',
      description: 'Ongoing optimization and refinement of processes'
    }
  ];

  const benefits = [
    'Optimize workflow efficiency across departments',
    'Implement best-practice management systems',
    'Streamline organizational processes for better results',
    'Enhance operational transparency and control',
    'Drive continuous improvement culture',
    'Reduce operational costs and waste'
  ];

  const technologies = [
    { icon: '📊', name: 'ERP Systems' },
    { icon: '📋', name: 'CRM Platforms' },
    { icon: '🔄', name: 'BPM Tools' },
    { icon: '📈', name: 'BI & Analytics' },
    { icon: '☁️', name: 'Cloud Solutions' },
    { icon: '🔗', name: 'Integration Tools' },
    { icon: '📱', name: 'Mobile Solutions' },
    { icon: '🤖', name: 'RPA Tools' }
  ];

  const industries = [
    'Construction', 'Manufacturing', 'Mining', 'Oil & Gas',
    'Food Industry', 'Logistics', 'Healthcare', 'Retail'
  ];

  const process = [
    { title: 'Assessment', description: 'Evaluate current systems and identify opportunities' },
    { title: 'Strategy', description: 'Develop customized management framework' },
    { title: 'Implementation', description: 'Deploy solutions with minimal disruption' },
    { title: 'Optimization', description: 'Monitor, measure, and refine for excellence' }
  ];

  return (
    <ServiceTemplate
      title="Management System Consulting"
      badge="MANAGEMENT CONSULTING"
      description="Strategic optimization of business processes through expert management systems implementation. We help you achieve operational excellence and sustainable growth."
      heroImage={consultingImg}
      features={features}
      benefits={benefits}
      technologies={technologies}
      industries={industries}
      process={process}
      ctaText="Book Consultation"
      ctaLink="/contact"
    />
  );
};

export default ManagementSystemConsulting;